import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { TextField } from 'redux-form-material-ui';
import { Toggle } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';
import { Field } from 'redux-form';
import { required } from '../../lib/validators';
import CheckBoxGroup from '../../lib/CheckBoxGroup';

const ServerForm = ( props ) => {
    const {handleSubmit, deleteServer, availableCountries} = props;

    const styles = {
        block: {
            maxWidth: 250,
        },
        toggle: {
            marginBottom: 16,
        },
        thumbOff: {
            backgroundColor: '#ffcccc',
        },
        trackOff: {
            backgroundColor: '#ff9d9d',
        },
        thumbSwitched: {
            backgroundColor: 'red',
        },
        trackSwitched: {
            backgroundColor: '#ff9d9d',
        },
        labelStyle: {
            color: 'red',
        },
    };

    return (
        <form onSubmit={handleSubmit}>
            <Grid fluid>
                <Row>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <h2>{props.server ? (props.server.id === 0 ? "Add server" : "Edit server") : ""}</h2>
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6}>
                        <div style={{textAlign: 'right', marginTop: '15px'}}>
                            {props.server && <RaisedButton type="submit" primary={true} label="Save" style={{margin: '5px'}}/>}
                            {props.server && (props.server.id !== undefined && <RaisedButton type="button" backgroundColor="#fff" label="Delete" onTouchTap={deleteServer} style={{margin: '5px'}} />)}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={8} sm={8} md={8} lg={8} >
                        <div>
                            <Field name="name" validate={[required]} component={TextField} hintText="Name" floatingLabelText="Name" />
                        </div>
                        <div>
                            <Field name="url" validate={[required]} component={TextField} hintText="URL" floatingLabelText="URL" />
                        </div>
                        <div style={styles.block}>
                            <Field name="enabled" style={styles.toggle} component={Toggle} label="Enabled" />
                        </div>
                            <CheckBoxGroup name="selectedCountries" options={availableCountries}/>
                    </Col>
                </Row>
            </Grid>
        </form>
    )
};

export default ServerForm;


// WEBPACK FOOTER //
// ./src/components/serverForm/ServerForm.js